import React, { useState } from "react";
import { CarouselStyled } from "./styles";
import { RoundButton } from "../../assets/styles/RoudeButton";
import { FaLongArrowAltLeft } from "react-icons/fa";
import { FaLongArrowAltRight } from "react-icons/fa";

interface ImageCarouselProps {
	images: { id: number; url: string }[];
}

export const ImageCarousel: React.FC<ImageCarouselProps> = ({ images }) => {
	const [currentImageIndex, setCurrentImageIndex] = useState(0);

	const handleNextImage = () => {
		setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
	};

	const handlePrevImage = () => {
		setCurrentImageIndex(
			(prevIndex) => (prevIndex - 1 + images.length) % images.length
		);
	};

	return (
		<CarouselStyled>
			<img
				src={
					images[
						currentImageIndex === images.length || currentImageIndex > images.length
							? 0
							: currentImageIndex
					].url
				}
				alt={`${currentImageIndex === images.length || currentImageIndex > images.length
					? 0
					: currentImageIndex
					}`}
			/>
			{images.length > 1 && (
				<div className="image-navigation">
					<abbr title="Imagem anterior">
						<RoundButton type="button" onClick={handlePrevImage}>
							<FaLongArrowAltLeft color="white" />
						</RoundButton>
					</abbr>
					<abbr title="Póxima imagem">
						<RoundButton type="button" onClick={handleNextImage}>
							<FaLongArrowAltRight color="white" />
						</RoundButton>
					</abbr>
				</div>
			)}
		</CarouselStyled>
	);
};
